import script from "./grid-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./grid-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./grid-setting-ly.vue?vue&type=style&index=0&id=4f806ca3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f806ca3"]])

export default __exports__